<div class="search-bar desktop-only-flex">
  <input
    type="text"
    [formControl]="text"
    placeholder="Rechercher..."
    (focus)="text.value.length >= 2 ? showResults = true : null"
    (keyup.enter)="searchGlobal()"
  />
  <button (click)="searchGlobal()">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="10" cy="10" r="7"></circle>
      <line x1="21" y1="21" x2="15.5" y2="15.5"></line>
    </svg>
  </button>

  <ng-container *ngTemplateOutlet="resultsTemplate"></ng-container>
</div>

<div class="mobile-search-drawer">
    <div class="search-bar-inner">
      <input
        type="text"
        [formControl]="text"
        placeholder="Je cherche un jeu..."
        (focus)="text.value.length >= 2 ? showResults = true : null"
        (keyup.enter)="searchGlobal()"
      />
      <button (click)="searchGlobal()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="10" cy="10" r="7"></circle>
          <line x1="21" y1="21" x2="15.5" y2="15.5"></line>
        </svg>
      </button>
    </div>

    <div class="mobile-results-container">
       <ng-container *ngTemplateOutlet="resultsTemplate"></ng-container>
    </div>
</div>

<ng-template #resultsTemplate>
  <div class="sb-result-dropdown" *ngIf="showResults && text.value.length >= 2">

    <div *ngIf="loading" class="sb-loading-state">Recherche...</div>

    <div *ngIf="!loading && products.length === 0 && scategSelected.length === 0" class="sb-no-content">
      Aucun résultat.
    </div>

    <ng-container *ngIf="!loading">

      <a *ngFor="let scateg of scategSelected"
         [routerLink]="route.parse('products-list', ['scateg', scateg.ident, scateg.name])"
         (click)="closeResults()"
         class="sb-result-item sb-category">
        <i class="fa-solid fa-arrow-right"></i>
        <span><b>Catégorie :</b> {{ scateg.name }}</span>
      </a>

      <a *ngFor="let gamme of gammeSelected"
         [routerLink]="route.parse('products-list', ['gamme', gamme.ident, gamme.name])"
         (click)="closeResults()"
         class="sb-result-item sb-category">
        <i class="fa-solid fa-arrow-right"></i>
        <span><b>Rayon :</b> {{ gamme.name }}</span>
      </a>

      <a *ngFor="let product of products"
         [routerLink]="route.parse('product', [product.ident])"
         (click)="closeResults()"
         class="sb-result-item sb-product">
        <span class="sb-img-container">
          <img [src]="getImage(product)" [alt]="product.name" />
        </span>
        <span class="sb-product-info">
          <b>{{ product.name }}</b>
          <small *ngIf="product.subtitle">{{ product.subtitle }}</small>
        </span>
      </a>

      <a *ngIf="products.length > 0"
        [routerLink]="route.parse('product-search', [text.value])"
        (click)="closeResults()"
        class="sb-result-item sb-all-results pointer">
        Voir tous les résultats pour "{{ text.value }}"
      </a>
    </ng-container>
  </div>
</ng-template>

<div class="click-outside-overlay" *ngIf="showResults" (click)="closeResults()"></div>
